if (!customElements.get('foundation-ingredients')) {
  customElements.define('foundation-ingredients', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.dialog = this.querySelector('dialog');
      this.trigger = this.querySelector('.formthr-ingredients-button');
      if (!this.dialog || !this.trigger) return;
      this.initialized = true;
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
      this.trigger.addEventListener('click', () => {
        const layout = this.closest('.mthr-product-layout, .product');
        const selected = layout?.querySelector('.formthr-buy-box__flavor--active');
        const flavor = selected?.dataset.flavorName?.toLowerCase();
        const tab = this.tabs.find(tab => tab.dataset.ingredientFlavor === flavor);
        this.selectFlavor(tab || this.tabs[0]);
        this.previousOverflow = document.documentElement.style.overflow;
        this.dialog.showModal();
        this.trigger.setAttribute('aria-expanded', 'true');
        document.documentElement.style.overflow = 'hidden';
      });
      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.selectFlavor(tab));
        tab.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
          if (event.key === 'ArrowLeft') next = (index - 1 + this.tabs.length) % this.tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = this.tabs.length - 1;
          if (next === undefined) return;
          event.preventDefault();
          this.selectFlavor(this.tabs[next]);
          this.tabs[next].focus();
        });
      });
      this.querySelector('.formthr-ingredients-drawer__close').addEventListener('click', () => this.dialog.close());
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
      });
      this.dialog.addEventListener('close', () => {
        document.documentElement.style.overflow = this.previousOverflow || '';
        this.trigger.setAttribute('aria-expanded', 'false');
        if (this.trigger.isConnected) this.trigger.focus();
      });
    }
    selectFlavor(selected) {
      if (!selected) return;
      this.tabs.forEach(tab => {
        const active = tab === selected;
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
      });
      this.panels.forEach(panel => { panel.hidden = panel.id !== selected.getAttribute('aria-controls'); });
      this.querySelector('.formthr-ingredients-drawer__body').scrollTop = 0;
    }
    disconnectedCallback() {
      if (this.dialog?.open) {
        this.dialog.close();
        document.documentElement.style.overflow = this.previousOverflow || '';
      }
    }
  });
}
